<script setup lang="ts">
import { updateAsAdmin } from '~~/src/api/elementals'
import type { List } from '~~/src/types/list'

interface IProps {
  list?: List
}
const props = defineProps<IProps>()
const { list } = toRefs(props)

const { colors } = useTheme()

const user = useUser()
const adminTools = useAdminTools()

const isError = ref<null | boolean>(null)
const handleUpdateList = async (values: { isHidden?: boolean; isFeatured?: boolean; companiesSection?: boolean }) => {
  if (!list?.value)
    return

  isError.value = null
  isError.value = !!(await updateAsAdmin(list.value.id, values))

  window.location.reload()
}
</script>

<template>
  <div v-if="user?.isAdmin && adminTools" flex flex-col gap-2>
    <PopupMenu>
      <AppButton
        variant="outline"
        class="!p-3" h="42px"
        title="Toggle Admin Menu"
      >
        <div i-material-symbols-more-horiz color-amber />
      </AppButton>

      <template #content>
        <AppFloatingMenu>
          <ul>
            <NuxtLink v-if="list" :to="`/list/${list.url || list.id}/edit`">
              <AppFloatingMenuItem :style="{ color: colors.admin }" cursor-pointer>
                Edit
              </AppFloatingMenuItem>
            </NuxtLink>
            <AppFloatingMenuItem :style="{ color: colors.admin }" cursor-pointer @click="(handleUpdateList({ isHidden: false }))">
              Unhide
            </AppFloatingMenuItem>
            <AppFloatingMenuItem :style="{ color: colors.admin }" cursor-pointer @click="(handleUpdateList({ isHidden: true }))">
              Hide
            </AppFloatingMenuItem>
            <AppFloatingMenuItem :style="{ color: colors.admin }" cursor-pointer @click="(handleUpdateList({ companiesSection: true }))">
              Add Company Section
            </AppFloatingMenuItem>
            <AppFloatingMenuItem :style="{ color: colors.admin }" cursor-pointer @click="(handleUpdateList({ companiesSection: false }))">
              Remove Company Section
            </AppFloatingMenuItem>
          </ul>
        </AppFloatingMenu>
      </template>
    </PopupMenu>

    <Text v-if="isError !== null" :color="isError ? colors.bluishDark : colors.orange">
      {{ isError ? 'Admin request succeeded' : 'Admin request failed' }}
    </Text>
  </div>
</template>
